import { Controller } from "@hotwired/stimulus"

// Moves the period to match the report type.
//
// A Morning Note covers one day. The form used to default to a seven-day
// window whatever was selected, so the type that describes a single morning
// came pre-filled with a week — and a week's figures went out under the word
// "Yesterday". The server rejects that combination now; this stops anyone
// having to be told.
const PERIODS = {
  morning_note: () => {
    const day = shift(new Date(), -1)
    return [day, day]
  },
  weekly_pulse: () => {
    const end = shift(new Date(), -1)
    return [shift(end, -6), end]
  },
  monthly_pulse: () => lastWholeMonth(),
  monthly_deep_dive: () => lastWholeMonth(),
  quarterly_review: () => {
    const now = new Date()
    const start = new Date(now.getFullYear(), Math.floor(now.getMonth() / 3) * 3 - 3, 1)
    return [start, new Date(start.getFullYear(), start.getMonth() + 3, 0)]
  },
  yearly_review: () => {
    const year = new Date().getFullYear() - 1
    return [new Date(year, 0, 1), new Date(year, 11, 31)]
  }
}

function shift(date, days) {
  const moved = new Date(date)
  moved.setDate(moved.getDate() + days)
  return moved
}

function lastWholeMonth() {
  const now = new Date()
  const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
  return [start, new Date(now.getFullYear(), now.getMonth(), 0)]
}

function iso(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
}

export default class extends Controller {
  static targets = ["start", "end"]

  suggest(event) {
    const period = PERIODS[event.target.value]
    if (!period) return

    const [start, end] = period()
    this.startTarget.value = iso(start)
    this.endTarget.value = iso(end)
  }
}
